{
  "invoices": "Invoices",
  "contactSupportForAssistance": "if you require additional assistance, please ",
  "paymentProcessed": "Thank you! Your payment has been processed. Redirecting you to the app...",
  "pay": "Pay {{ amount }}",
  "paymentComplete": "Payment Completed!",
  "callout": "1 outstanding payment totaling {{ amount }} is due",
  "callout_plural": "{{ count }} outstanding payments totaling {{ amount }} are due",
  "errorDetails": "We are unable to charge your credit card ending in {{ card }} and received the following bank error message: <strong>{{ message }}</strong> Please update your billing information to continue with our service.",
  "downgradeInfo": "If we don't receive your payment, your account will be moved to our <a href='https://$t(common:defaultHost)/pricing' target='_blank'>free Community plan</a>, which is live tail only and none of your logs/data will be retained.",
  "anyQuestions": "If you have any questions, feel free to",
  "contactSupport": "contact our support team"
}
